import { createUsersApi } from "../../api-helpers/UserApiHelper";

export const userCache = new Map<string, string>();
const usersApi = createUsersApi();

export const UserNameResolver = (userId: string) => {

    if (!userId || userId === "") return;
    if (!userCache.has(userId)) {
        loadUserData(userId).then(user => {
            return user;
        }).catch((error) => {
            console.error(error);
            return "-";
        });
    }
    return userCache.get(userId);
};

async function loadUserData(userId: string): Promise<string> {
    if (!userCache.get(userId)) {
        try {

            const usersResponse = await usersApi.usersControllerFindOne(userId);
            userCache.set(userId, usersResponse.data.firstName + " " + usersResponse.data.lastName);

        } catch (error) {
            console.error(error);
        }
    }

    return userCache.get(userId) || '';
}
